module.exports = __webpack_public_path__ + "static/media/patientholistic-icon-01.cb17d547.png";